export const signInFormFields = [
  {
    label: 'user.username.or.email',
    name: 'email',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'user.password',
    name: 'password',
    type: 'password',
    required: true,
    className: '',
    grid: { xs: 12 },
  },
];

export const filterFormFields = [
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 12 },
    options: [],
  },
  // { label: 'filter.model', type: 'header', className: '', grid: { xs: 12 } },
  // {
  //   label: 'filter.model.A01',
  //   name: 'model.A01',
  //   type: 'checkbox',
  //   className: '',
  //   grid: { xs: 6 },
  // },
  // {
  //   label: 'filter.model.A02',
  //   name: 'model.A02',
  //   type: 'checkbox',
  //   className: '',
  //   grid: { xs: 6 },
  // },
  // {
  //   label: 'filter.model.A03',
  //   name: 'model.A03',
  //   type: 'checkbox',
  //   className: '',
  //   grid: { xs: 6 },
  // },
  // {
  //   label: 'filter.model.A04',
  //   name: 'model.A04',
  //   type: 'checkbox',
  //   className: '',
  //   grid: { xs: 6 },
  // },
  { label: 'filter.time', type: 'header', className: '', grid: { xs: 12 } },
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    default: { display: 'month.all', value: 'all' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 12 },
    options: [
      { display: 'filter.batch.1', value: '1' },
      { display: 'filter.batch.2', value: '2' },
      { display: 'filter.batch.3', value: '3' },
      { display: 'filter.batch.4', value: '4' },
    ],
  },
  { label: 'filter.dealer', type: 'header', className: '', grid: { xs: 12 } },
  {
    label: 'dealer.dealer_name.headoffice',
    name: 'dealer.ho_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12 },
    default: { display: 'dealer.dealer_name.headoffice.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.dealer_name.branch',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12 },
    default: { display: 'dealer.dealer_name.branch.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.region',
    name: 'dealer.region',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 12 },
    default: { display: 'dealer.region.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.area',
    name: 'dealer.area',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 12 },
    default: { display: 'dealer.area.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.province',
    name: 'dealer.province',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12 },
    default: { display: 'dealer.province.all', value: 'all' },
    options: [],
  },
];

export const ticketSearchFormFields = [
  {
    label: 'ticket.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 12, md: 2 },
    options: [],
  },
  {
    label: 'ticket.search.from_date',
    name: 'from_created_date',
    type: 'date',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'ticket.search.to_date',
    name: 'to_created_date',
    type: 'date',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.dealer_name.headoffice',
    name: 'dealer.ho_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12, md: 4 },
    default: { display: 'dealer.dealer_name.headoffice.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.region',
    name: 'dealer.region',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 12, md: 2 },
    default: { display: 'dealer.region.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.area',
    name: 'dealer.area',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 12, md: 3 },
    default: { display: 'dealer.area.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.province',
    name: 'dealer.province',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12, md: 3 },
    default: { display: 'dealer.province.all', value: 'all' },
    options: [],
  },
  {
    label: 'dealer.dealer_name.branch',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 12, md: 4 },
    default: { display: 'dealer.dealer_name.branch.all', value: 'all' },
    options: [],
  },
  {
    label: 'ticket.customer_service',
    name: 'customer_service',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 12, md: 12 },
    default: { display: 'ticket.customer_service.PM+GR', value: 'all' },
    options: [
      { display: 'ticket.customer_service.GR', value: 'GR' },
      { display: 'ticket.customer_service.PM', value: 'PM' },
    ],
  },
];

export const ticketSSIFormFields = [
  {
    label: 'ticket.info.customer',
    type: 'header',
    variant: 'h3',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.case_no',
    name: 'case_no',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.customer_name',
    name: 'customer_name',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.chassis_no',
    name: 'chassis_no',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.interviewed_date',
    name: 'interviewed_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.phone',
    name: 'phone',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.model_name',
    name: 'model_name',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.reported_date',
    name: 'reported_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.delivered_date',
    name: 'delivered_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.engine_no',
    name: 'engine_no',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'dealer.dealer_code.ssi',
    name: 'dealer.dealer_code',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 2 },
  },
  {
    label: 'dealer.dealer_name_th.ssi',
    name: 'dealer.dealer_name_th',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6 },
  },
  {
    label: 'dealer.dealer_name_en.ssi',
    name: 'dealer.dealer_name_en',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6 },
  },
  {
    label: 'ticket.ssi_name',
    name: 'ssi_name',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'ticket.info.redalert',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.qn_th',
    name: 'qn_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.qn_en',
    name: 'qn_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q4',
    name: 'q4',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q4_full',
    name: 'q4_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.description_th',
    name: 'description_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.description_en',
    name: 'description_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q11_th',
    name: 'q11_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q11_en',
    name: 'q11_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q11',
    name: 'q11',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q11_full',
    name: 'q11_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q11oe_th',
    name: 'q11oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q11oe_en',
    name: 'q11oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q15_th',
    name: 'q15_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q15_en',
    name: 'q15_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q15',
    name: 'q15',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q15_full',
    name: 'q15_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q15oe_th',
    name: 'q15oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q15oe_en',
    name: 'q15oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q17_th',
    name: 'q17_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q17_en',
    name: 'q17_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q17',
    name: 'q17',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q17_full',
    name: 'q17_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q17oe_th',
    name: 'q17oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q17oe_en',
    name: 'q17oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q18_th',
    name: 'q18_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q18_en',
    name: 'q18_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q18',
    name: 'q18',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q18_full',
    name: 'q18_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q18oe_th',
    name: 'q18oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q18oe_en',
    name: 'q18oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q27_th',
    name: 'q27_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q27_en',
    name: 'q27_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q27',
    name: 'q27',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q27_full',
    name: 'q27_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q27oe_th',
    name: 'q27oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q27oe_en',
    name: 'q27oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q9_th',
    name: 'q9_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q9_en',
    name: 'q9_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q9',
    name: 'q9',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q9_full',
    name: 'q9_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q9oe_th',
    name: 'q9oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q9oe_en',
    name: 'q9oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.disclosure_company',
    name: 'disclosure_company',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 6 },
  },
  {
    label: 'ticket.disclosure_dealer',
    name: 'disclosure_dealer',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 6 },
  },
  {
    label: 'ticket.info.action',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.solution_detail',
    name: 'solution_detail',
    type: 'textarea',
    multiline: true,
    required: true,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  // {
  //   label: 'ticket.dealer_date',
  //   name: 'dealer_date',
  //   type: 'date',
  //   disabled: true,
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  // },
  {
    label: 'ticket.solution_result',
    name: 'solution_result',
    type: 'textarea',
    multiline: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  {
    label: 'ticket.expected_date',
    name: 'expected_date',
    type: 'date',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'ticket.solution_protect',
    name: 'solution_protect',
    type: 'textarea',
    multiline: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  // {
  //   label: 'ticket.completed_date',
  //   name: 'completed_date',
  //   type: 'date',
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  // },
  {
    label: 'ticket.info.management',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  { label: 'ticket.info.am', type: 'header', variant: 'h4', grid: { xs: 12 } },
  {
    label: 'ticket.am_comment',
    name: 'am_comment',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.am_status',
    name: 'am_status',
    type: 'dropdown',
    disabled: true,
    required: false,
    className: '',
    options: [
      { display: 'ticket.am_status.A', value: 'A' },
      { display: 'ticket.am_status.R', value: 'R' },
    ],
    grid: { xs: 4 },
  },
  // {
  //   label: 'ticket.am_date',
  //   name: 'am_date',
  //   type: 'date',
  //   disabled: true,
  //   required: false,
  //   className: '',
  //   grid: { xs: 8 },
  // },
  { label: 'ticket.info.gm', type: 'header', variant: 'h4', grid: { xs: 12 } },
  {
    label: 'ticket.gm_comment',
    name: 'gm_comment',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.gm_status',
    name: 'gm_status',
    type: 'dropdown',
    disabled: true,
    required: false,
    className: '',
    options: [
      { display: 'ticket.gm_status.A', value: 'A' },
      { display: 'ticket.gm_status.R', value: 'R' },
    ],
    grid: { xs: 4 },
  },
  // {
  //   label: 'ticket.gm_date',
  //   name: 'gm_date',
  //   type: 'date',
  //   disabled: true,
  //   required: false,
  //   className: '',
  //   grid: { xs: 8 },
  // },
];

export const ticketCSIFormFields = [
  {
    label: 'ticket.info.customer',
    type: 'header',
    variant: 'h3',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.case_no',
    name: 'case_no',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.customer_name',
    name: 'customer_name',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.chassis_no',
    name: 'chassis_no',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.interviewed_date',
    name: 'interviewed_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.phone',
    name: 'phone',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.model_name',
    name: 'model_name',
    type: 'text',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.reported_date',
    name: 'reported_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.serviced_date',
    name: 'serviced_date',
    type: 'date',
    disabled: true,
    required: true,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'ticket.engine_no',
    name: 'engine_no',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 4 },
  },
  {
    label: 'dealer.dealer_code.csi',
    name: 'dealer.dealer_code',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 2 },
  },
  {
    label: 'dealer.dealer_name_th.csi',
    name: 'dealer.dealer_name_th',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6 },
  },
  {
    label: 'dealer.dealer_name_en.ssi',
    name: 'dealer.dealer_name_en',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6 },
  },
  {
    label: 'ticket.csi_name',
    name: 'csi_name',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'ticket.info.redalert',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.qn_th',
    name: 'qn_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.qn_en',
    name: 'qn_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q4',
    name: 'q4',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q4_full',
    name: 'q4_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.description_th',
    name: 'description_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.description_en',
    name: 'description_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q7_th',
    name: 'q7_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q7_en',
    name: 'q7_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q7',
    name: 'q7',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q7_full',
    name: 'q7_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q7oe_th',
    name: 'q7oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q7oe_en',
    name: 'q7oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q11_th',
    name: 'q11_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q11_en',
    name: 'q11_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q11',
    name: 'q11',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q11_full',
    name: 'q11_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q11oe_th',
    name: 'q11oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q11oe_en',
    name: 'q11oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q18_th',
    name: 'q18_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q18_en',
    name: 'q18_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q18',
    name: 'q18',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q18_full',
    name: 'q18_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q18oe_th',
    name: 'q18oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q18oe_en',
    name: 'q18oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q23_th',
    name: 'q23_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q23_en',
    name: 'q23_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q23',
    name: 'q23',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q23_full',
    name: 'q23_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q23oe_th',
    name: 'q23oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q23oe_en',
    name: 'q23oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q29_th',
    name: 'q29_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q29_en',
    name: 'q29_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q29',
    name: 'q29',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q29_full',
    name: 'q29_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q29oe_th',
    name: 'q29oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q29oe_en',
    name: 'q29oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q33_th',
    name: 'q33_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q33_en',
    name: 'q33_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q33',
    name: 'q33',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q33_full',
    name: 'q33_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q33oe_th',
    name: 'q33oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q33oe_en',
    name: 'q33oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q9_th',
    name: 'q9_th',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q9_en',
    name: 'q9_en',
    type: 'text',
    multiline: true,
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 8 },
  },
  {
    label: 'ticket.q9',
    name: 'q9',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q9_full',
    name: 'q9_full',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 2 },
  },
  {
    label: 'ticket.q9oe_th',
    name: 'q9oe_th',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.q9oe_en',
    name: 'q9oe_en',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 5,
    maxRows: 8,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.disclosure_company',
    name: 'disclosure_company',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 6 },
  },
  {
    label: 'ticket.disclosure_dealer',
    name: 'disclosure_dealer',
    type: 'text',
    disabled: true,
    required: false,
    className: '',
    grid: { xs: 6, md: 6 },
  },
  {
    label: 'ticket.info.action',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.solution_detail',
    name: 'solution_detail',
    type: 'textarea',
    multiline: true,
    required: true,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  // {
  //   label: 'ticket.dealer_date',
  //   name: 'dealer_date',
  //   type: 'date',
  //   disabled: true,
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  // },
  {
    label: 'ticket.solution_result',
    name: 'solution_result',
    type: 'textarea',
    multiline: true,
    required: true,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  {
    label: 'ticket.expected_date',
    name: 'expected_date',
    type: 'date',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'ticket.solution_protect',
    name: 'solution_protect',
    type: 'textarea',
    multiline: true,
    required: true,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 8 },
  },
  // {
  //   label: 'ticket.completed_date',
  //   name: 'completed_date',
  //   type: 'date',
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  // },
  {
    label: 'ticket.info.management',
    type: 'header',
    variant: 'h3',
    className: 'mt-5 pt-5',
    grid: { xs: 12 },
  },
  { label: 'ticket.info.am', type: 'header', variant: 'h4', grid: { xs: 12 } },
  {
    label: 'ticket.am_comment',
    name: 'am_comment',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.am_status',
    name: 'am_status',
    type: 'dropdown',
    disabled: true,
    required: false,
    className: '',
    options: [
      { display: 'ticket.am_status.A', value: 'A' },
      { display: 'ticket.am_status.R', value: 'R' },
    ],
    grid: { xs: 4 },
  },
  // {
  //   label: 'ticket.am_date',
  //   name: 'am_date',
  //   type: 'date',
  //   disabled: true,
  //   required: false,
  //   className: '',
  //   grid: { xs: 8 },
  // },
  { label: 'ticket.info.gm', type: 'header', variant: 'h4', grid: { xs: 12 } },
  {
    label: 'ticket.gm_comment',
    name: 'gm_comment',
    type: 'textarea',
    multiline: true,
    disabled: true,
    required: false,
    minRows: 3,
    maxRows: 5,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'ticket.gm_status',
    name: 'gm_status',
    type: 'dropdown',
    disabled: true,
    required: false,
    className: '',
    options: [
      { display: 'ticket.gm_status.A', value: 'A' },
      { display: 'ticket.gm_status.R', value: 'R' },
    ],
    grid: { xs: 4 },
  },
  // {
  //   label: 'ticket.gm_date',
  //   name: 'gm_date',
  //   type: 'date',
  //   disabled: true,
  //   required: false,
  //   className: '',
  //   grid: { xs: 8 },
  // },
];

export const reportFwProgressFormFields = [
  {
    label: 'survey.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'survey.type.ssi', value: 'ssi' },
      { display: 'survey.type.csi-pm', value: 'csi-pm' },
      { display: 'survey.type.csi-gr', value: 'csi-gr' },
    ],
  },
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
];

export const reportQCDataFormFields = [
  {
    label: 'ticket.search.from_date',
    name: 'from_created_date',
    type: 'date',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'ticket.search.to_date',
    name: 'to_created_date',
    type: 'date',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
];

export const reportCustomerListFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    default: { display: 'month.ytd', value: 'ytd' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
  {
    label: 'dealer.dealer_name',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 9 },
    default: { display: 'dealer.dealer_name.all', value: 'all' },
    options: [],
  },
];

export const reportInterviewFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    default: { display: 'month.ytd', value: 'ytd' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
  {
    label: 'dealer.dealer_name',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 9 },
    default: { display: 'dealer.dealer_name.all', value: 'all' },
    options: [],
  },
];

export const reportDropOffFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    default: { display: 'month.ytd', value: 'ytd' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
  {
    label: 'dealer.dealer_name',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 9 },
    default: { display: 'dealer.dealer_name.all', value: 'all' },
    options: [],
  },
];

export const reportMonthlyFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 6 },
    default: { display: 'month.ytd', value: 'ytd' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 12 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
];

export const reportToplineFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    default: { display: 'month.ytd', value: 'ytd' },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
  {
    label: 'dealer.dealer_name',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 9 },
    default: { display: 'dealer.dealer_name.all', value: 'all' },
    options: [],
  },
];

export const reportToplinePdfFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  // {
  //   label: 'month',
  //   name: 'month',
  //   type: 'dropdown',
  //   required: true,
  //   className: '',
  //   grid: { xs: 8 },
  //   default: { display: 'month.ytd', value: 'ytd' },
  //   options: [
  //     { display: 'month.01', value: '01' },
  //     { display: 'month.02', value: '02' },
  //     { display: 'month.03', value: '03' },
  //     { display: 'month.04', value: '04' },
  //     { display: 'month.05', value: '05' },
  //     { display: 'month.06', value: '06' },
  //     { display: 'month.07', value: '07' },
  //     { display: 'month.08', value: '08' },
  //     { display: 'month.09', value: '09' },
  //     { display: 'month.10', value: '10' },
  //     { display: 'month.11', value: '11' },
  //     { display: 'month.12', value: '12' },
  //   ],
  // },
  // {
  //   label: 'batch',
  //   name: 'batch',
  //   type: 'dropdown',
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  //   options: [
  //     { display: 'batch.all', value: 'all' },
  //     { display: 'batch.1', value: '1' },
  //     { display: 'batch.2', value: '2' },
  //     { display: 'batch.3', value: '3' },
  //     { display: 'batch.4', value: '4' },
  //   ],
  // },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
  {
    label: 'dealer.dealer_name',
    name: 'dealer_code',
    type: 'autocomplete',
    required: false,
    className: '',
    grid: { xs: 6 },
    default: { display: 'dealer.dealer_name.all', value: 'all' },
    options: [],
  },
];

export const reportToplinePivotFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  // {
  //   label: 'month',
  //   name: 'month',
  //   type: 'dropdown',
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  //   options: [
  //     { display: 'month.01', value: '01' },
  //     { display: 'month.02', value: '02' },
  //     { display: 'month.03', value: '03' },
  //     { display: 'month.04', value: '04' },
  //     { display: 'month.05', value: '05' },
  //     { display: 'month.06', value: '06' },
  //     { display: 'month.07', value: '07' },
  //     { display: 'month.08', value: '08' },
  //     { display: 'month.09', value: '09' },
  //     { display: 'month.10', value: '10' },
  //     { display: 'month.11', value: '11' },
  //     { display: 'month.12', value: '12' },
  //   ],
  // },
  // {
  //   label: 'batch',
  //   name: 'batch',
  //   type: 'dropdown',
  //   required: true,
  //   className: '',
  //   grid: { xs: 4 },
  //   options: [
  //     { display: 'batch.1', value: '1' },
  //     { display: 'batch.2', value: '2' },
  //     { display: 'batch.3', value: '3' },
  //     { display: 'batch.4', value: '4' },
  //   ],
  // },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 8 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
];

export const reportExportRawDataFormFields = [
  {
    label: 'year',
    name: 'year',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'year.2026', value: '2026' },
      { display: 'year.2025', value: '2025' },
      { display: 'year.2024', value: '2024' },
      { display: 'year.2023', value: '2023' },
      { display: 'year.2022', value: '2022' },
    ],
  },
  {
    label: 'month',
    name: 'month',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'month.01', value: '01' },
      { display: 'month.02', value: '02' },
      { display: 'month.03', value: '03' },
      { display: 'month.04', value: '04' },
      { display: 'month.05', value: '05' },
      { display: 'month.06', value: '06' },
      { display: 'month.07', value: '07' },
      { display: 'month.08', value: '08' },
      { display: 'month.09', value: '09' },
      { display: 'month.10', value: '10' },
      { display: 'month.11', value: '11' },
      { display: 'month.12', value: '12' },
    ],
  },
  {
    label: 'batch',
    name: 'batch',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 4 },
    options: [
      { display: 'batch.all', value: 'all' },
      { display: 'batch.1', value: '1' },
      { display: 'batch.2', value: '2' },
      { display: 'batch.3', value: '3' },
      { display: 'batch.4', value: '4' },
    ],
  },
  {
    label: 'filter.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 12 },
    options: [
      { display: 'filter.type.ssi', value: 'ssi' },
      { display: 'filter.type.csi', value: 'csi' },
    ],
  },
];

export const userSearchFormFields = [
  {
    label: 'user.username',
    name: 'username',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'user.first_name',
    name: 'first_name',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'user.last_name',
    name: 'last_name',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'user.email',
    name: 'email',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'user.active_flag',
    name: 'active_flag',
    required: false,
    type: 'dropdown',
    className: '',
    options: [
      { display: 'user.active_flag.1', value: '1' },
      { display: 'user.active_flag.0', value: '0' },
    ],
    grid: { xs: 6, md: 6 },
  },
  {
    label: 'user.type',
    name: 'type',
    type: 'dropdown',
    required: false,
    className: '',
    grid: { xs: 6, md: 6 },
    options: [
      { display: 'user.type.root', value: 'root' },
      { display: 'user.type.admin', value: 'admin' },
      { display: 'user.type.leader', value: 'leader' },
      { display: 'user.type.general_manager', value: 'general_manager' },
      { display: 'user.type.area_manager', value: 'area_manager' },
      { display: 'user.type.dealer', value: 'dealer' },
    ],
  },
];

export const userProfileFormFields = [
  {
    label: 'user.username',
    name: 'username',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.first_name',
    name: 'first_name',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.last_name',
    name: 'last_name',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.email',
    name: 'email',
    type: 'email',
    required: true,
    grid: { xs: 4 },
  },
  {
    label: 'user.mobile',
    name: 'mobile',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.position_title',
    name: 'position_title',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 4 },
  },
];

export const userProfilePasswordFormFields = [
  {
    label: 'user.password',
    name: 'password',
    type: 'password',
    required: true,
    className: '',
    grid: { xs: 12 },
  },
  {
    label: 'user.password_confirm',
    name: 'password_confirm',
    type: 'password',
    required: true,
    className: '',
    grid: { xs: 12 },
  },
];

export const userFormFields = [
  {
    label: 'user.username',
    name: 'username',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.first_name',
    name: 'first_name',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.last_name',
    name: 'last_name',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 4 },
  },
  {
    label: 'user.email',
    name: 'email',
    type: 'email',
    required: false,
    grid: { xs: 6 },
  },
  {
    label: 'user.password',
    name: 'password',
    type: 'password',
    required: true,
    className: '',
    grid: { xs: 6 },
  },
  {
    label: 'user.mobile',
    name: 'mobile',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 3 },
  },
  {
    label: 'user.position_title',
    name: 'position_title',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 3 },
  },
  {
    label: 'user.active_flag',
    name: 'active_flag',
    type: 'dropdown',
    required: true,
    grid: { xs: 3 },
    options: [
      { display: 'user.active_flag.1', value: '1' },
      { display: 'user.active_flag.0', value: '0' },
    ],
  },
  {
    label: 'user.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    grid: { xs: 3 },
    options: [
      { display: 'user.type.root', value: 'root' },
      { display: 'user.type.admin', value: 'admin' },
      { display: 'user.type.leader', value: 'leader' },
      { display: 'user.type.general_manager', value: 'general_manager' },
      { display: 'user.type.area_manager', value: 'area_manager' },
      { display: 'user.type.dealer', value: 'dealer' },
    ],
  },
  { label: 'user.group', type: 'header', grid: { xs: 12 } },
  { label: 'user.group.ssi', name: 'group.ssi', type: 'checkbox', grid: { xs: 3 } },
  { label: 'user.group.csi', name: 'group.csi', type: 'checkbox', grid: { xs: 3 } },
];

// DEALER
// REGION / AREA / ZONE / TYPE ARE FIXED SETS. THEY FEED THE TICKET FILTER
// DROPLISTS (TicketSearchForm.js), SO A FREE-TEXT TYPO WOULD CREATE A PHANTOM
// ENTRY THERE. PROVINCE OPTIONS ARE FILLED AT RUNTIME FROM THE DEALER
// COLLECTION — SEE DealerForm.js.
export const dealerRegionOptions = [
  { display: 'dealer.region.BKK', value: 'BKK' },
  { display: 'dealer.region.Central', value: 'Central' },
  { display: 'dealer.region.North', value: 'North' },
  { display: 'dealer.region.Northeast', value: 'Northeast' },
  { display: 'dealer.region.South', value: 'South' },
];

export const dealerAreaOptions = [
  'BKK1',
  'BKK2',
  'BKK3',
  'BKK4',
  'BKK5',
  'BKK6',
  'C1',
  'C2',
  'C3',
  'C4',
  'N1',
  'N2',
  'NE1',
  'NE2',
  'NE3',
  'NE4',
  'S1',
  'S2',
].map(value => ({ display: value, value, intl: false }));

export const dealerZoneOptions = ['Bangkok & Greater Area', 'Upcountry', 'Central'].map(value => ({
  display: value,
  value,
  intl: false,
}));

export const dealerTypeOptions = ['3S', '2S', '1S', 'TMP.', 'Temp.', 'Tentative'].map(value => ({
  display: value,
  value,
  intl: false,
}));

export const dealerFormFields = [
  {
    label: 'dealer.dealer_code',
    name: 'dealer_code',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.ho_code',
    name: 'ho_code',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.type',
    name: 'type',
    type: 'dropdown',
    required: true,
    className: '',
    options: dealerTypeOptions,
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.area_manager',
    name: 'area_manager',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.dealer_name_th',
    name: 'dealer_name_th',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 12, md: 6 },
  },
  {
    label: 'dealer.dealer_name_en',
    name: 'dealer_name_en',
    type: 'text',
    required: true,
    className: '',
    grid: { xs: 12, md: 6 },
  },
  {
    label: 'dealer.region',
    name: 'region',
    type: 'dropdown',
    required: true,
    className: '',
    options: dealerRegionOptions,
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.area',
    name: 'area',
    type: 'dropdown',
    required: true,
    className: '',
    options: dealerAreaOptions,
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.zone',
    name: 'zone',
    type: 'dropdown',
    required: true,
    className: '',
    options: dealerZoneOptions,
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.district',
    name: 'district',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 12, md: 3 },
  },
  {
    label: 'dealer.province_1',
    name: 'province_1',
    type: 'dropdown',
    required: true,
    className: '',
    options: [],
    grid: { xs: 12, md: 6 },
  },
  {
    // province_2 DRIVES THE PROVINCE DROPLIST IN THE TICKET FILTER
    label: 'dealer.province_2',
    name: 'province_2',
    type: 'dropdown',
    required: true,
    className: '',
    options: [],
    grid: { xs: 12, md: 6 },
  },
  { label: 'dealer.contact', type: 'header', grid: { xs: 12 } },
  {
    label: 'dealer.sales_manager_email',
    name: 'sales_manager_email',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 12, md: 6 },
  },
  {
    label: 'dealer.service_manager_email',
    name: 'service_manager_email',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 12, md: 6 },
  },
];

export const dealerSearchFormFields = [
  {
    label: 'dealer.dealer_code',
    name: 'dealer_code',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.ho_code',
    name: 'ho_code',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.dealer_name_th',
    name: 'dealer_name_th',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.dealer_name_en',
    name: 'dealer_name_en',
    type: 'text',
    required: false,
    className: '',
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.region',
    name: 'region',
    type: 'dropdown',
    required: false,
    className: '',
    options: dealerRegionOptions,
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.area',
    name: 'area',
    type: 'dropdown',
    required: false,
    className: '',
    options: dealerAreaOptions,
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.zone',
    name: 'zone',
    type: 'dropdown',
    required: false,
    className: '',
    options: dealerZoneOptions,
    grid: { xs: 6, md: 3 },
  },
  {
    label: 'dealer.type',
    name: 'type',
    type: 'dropdown',
    required: false,
    className: '',
    options: dealerTypeOptions,
    grid: { xs: 6, md: 3 },
  },
];
